/* alkaram-style.js — hover mega menu + card quick-add (opens cart drawer) */

document.addEventListener("DOMContentLoaded", () => {
  initMegaMenuHover();
  initDrawerParentLinks();
  initCardQuickAdd();
  initHeaderScrollBorder();
  initCarousels();
  initHeroSliders();
});

function initDrawerParentLinks() {
  // Tap "Men" / "Women" text → go to page; tap arrow → open categories (default)
  document.addEventListener(
    "click",
    (e) => {
      const link = e.target.closest("a[data-drawer-parent-link]");
      if (!link) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = link.href;
    },
    true
  );
}

function initHeaderScrollBorder() {
  const onScroll = () => {
    document.body.classList.toggle("header-is-scrolled", window.scrollY > 10);
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
}

function initCarousels() {
  document.querySelectorAll(".arrow[data-target]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const track = document.getElementById(btn.dataset.target);
      if (!track) return;
      const dir = btn.classList.contains("prev") ? -1 : 1;
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: "smooth" });
    });
  });

  document.querySelectorAll("[data-carousel-tabs]").forEach((wrap) => {
    const tabs = wrap.querySelectorAll("[data-carousel-tab]");
    const panes = wrap.querySelectorAll("[data-carousel-pane]");
    const viewAll = wrap.querySelector("[data-carousel-viewall]");
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const key = tab.dataset.carouselTab;
        tabs.forEach((el) => el.classList.toggle("is-active", el === tab));
        panes.forEach((pane) => {
          pane.hidden = pane.dataset.carouselPane !== key;
        });
        if (viewAll && tab.dataset.viewAll) viewAll.href = tab.dataset.viewAll;
      });
    });
  });
}

function initMegaMenuHover() {
  const menus = document.querySelectorAll("header-menu");
  if (!menus.length) return;

  const canHover = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  const reduceMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const CLOSE_MS = 400;

  menus.forEach((menu) => {
    const details = menu.querySelector("details");
    if (!details) return;
    const summary = details.querySelector("summary");
    let leaveTimer;
    let closeTimer;

    const syncChrome = () => {
      const anyOpen = [...menus].some((m) => {
        const d = m.querySelector("details");
        return d?.hasAttribute("open") && !d.classList.contains("is-closing");
      });
      document.body.classList.toggle("menu-open", anyOpen);
      document.querySelector(".section-header")?.classList.toggle("menu-open", anyOpen);
    };

    const closeInstant = (targetDetails) => {
      const d = targetDetails;
      const s = d?.querySelector("summary");
      if (!d) return;
      d.classList.remove("is-closing");
      d.removeAttribute("open");
      s?.setAttribute("aria-expanded", "false");
    };

    const openMenu = () => {
      clearTimeout(leaveTimer);
      clearTimeout(closeTimer);
      details.classList.remove("is-closing");
      menus.forEach((other) => {
        if (other === menu) return;
        closeInstant(other.querySelector("details"));
      });
      details.setAttribute("open", true);
      summary?.setAttribute("aria-expanded", "true");
      syncChrome();
    };

    const closeMenu = (animated) => {
      clearTimeout(leaveTimer);
      clearTimeout(closeTimer);
      if (!details.hasAttribute("open")) return;

      if (animated && !reduceMotion() && details.classList.contains("mega-menu")) {
        details.classList.add("is-closing");
        closeTimer = setTimeout(() => {
          details.removeAttribute("open");
          details.classList.remove("is-closing");
          summary?.setAttribute("aria-expanded", "false");
          syncChrome();
        }, CLOSE_MS);
        return;
      }

      closeInstant(details);
      syncChrome();
    };

    menu.addEventListener("mouseenter", () => {
      if (!canHover()) return;
      openMenu();
    });

    menu.addEventListener("mouseleave", () => {
      if (!canHover()) return;
      leaveTimer = setTimeout(() => closeMenu(true), 120);
    });

    // Desktop: click Women / Men → go to that page; hover still opens mega menu
    summary?.addEventListener("click", (e) => {
      const url = summary.getAttribute("data-menu-url");
      if (!url) return;
      if (canHover()) {
        e.preventDefault();
        window.location.href = url;
      }
    });
  });
}

function cartAddUrl() {
  const base = window.routes?.cart_add_url || "/cart/add";
  return base.endsWith(".js") ? base : `${base}.js`;
}

function openCartDrawer() {
  if (typeof window.openCartDrawer === "function") {
    window.openCartDrawer();
    return;
  }
  const drawer = document.querySelector("[data-cart-drawer]");
  if (drawer) {
    drawer.hidden = false;
    document.body.style.overflow = "hidden";
  }
}

async function addVariantToCart(variantId, plusBtn) {
  if (!variantId) throw new Error("Missing variant");
  plusBtn?.classList.add("is-adding");
  plusBtn?.setAttribute("aria-busy", "true");

  const res = await fetch(cartAddUrl(), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: 1,
    }),
  });

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(data?.description || data?.message || "This item couldn't be added to cart.");
  }

  plusBtn?.classList.add("is-added");
  document.dispatchEvent(new CustomEvent("cart:updated"));
  openCartDrawer();
}

function closeAllSizePanels(except) {
  document.querySelectorAll("[data-size-panel]").forEach((panel) => {
    if (panel === except) return;
    panel.hidden = true;
    panel.classList.remove("open");
  });
}

function initCardQuickAdd() {
  let adding = false;

  document.addEventListener("click", async (e) => {
    const closeBtn = e.target.closest("[data-size-panel-close]");
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const panel = closeBtn.closest("[data-size-panel]");
      if (panel) {
        panel.hidden = true;
        panel.classList.remove("open");
      }
      return;
    }

    const sizeChoice = e.target.closest("[data-size-variant]");
    if (sizeChoice) {
      e.preventDefault();
      e.stopPropagation();
      if (adding) return;
      if (sizeChoice.dataset.soldOut === "true") return;
      const card = sizeChoice.closest(".p-card, .card");
      const plusBtn = card?.querySelector(".card-plus");
      const variantInput = card?.querySelector("[data-variant-id]");
      const variantId = sizeChoice.dataset.sizeVariant;
      if (variantInput) variantInput.value = variantId;
      adding = true;
      try {
        await addVariantToCart(variantId, plusBtn);
        closeAllSizePanels();
      } catch (err) {
        console.error(err);
        alert(err?.message || "Sorry, that item couldn't be added. Please try again.");
      } finally {
        adding = false;
        plusBtn?.removeAttribute("aria-busy");
        setTimeout(() => plusBtn?.classList.remove("is-adding", "is-added"), 800);
      }
      return;
    }

    const panelToggle = e.target.closest("[data-open-size-panel]");
    if (panelToggle) {
      e.preventDefault();
      e.stopPropagation();
      const card = panelToggle.closest(".p-card, .card");
      const panel = card?.querySelector("[data-size-panel]");
      if (!panel) return;
      const willOpen = panel.hidden;
      closeAllSizePanels(panel);
      panel.hidden = !willOpen;
      panel.classList.toggle("open", willOpen);
      return;
    }

    const plusBtn = e.target.closest("[data-card-quick-add]");
    if (!plusBtn) return;

    e.preventDefault();
    e.stopPropagation();
    if (adding) return;

    const card = plusBtn.closest(".p-card, .card");
    const variantId = card?.querySelector("[data-variant-id]")?.value;
    if (!variantId) {
      window.location.href = card?.querySelector("a.p-card__link, a.card-title")?.href || "/";
      return;
    }

    adding = true;
    try {
      await addVariantToCart(variantId, plusBtn);
    } catch (err) {
      console.error(err);
      alert(err?.message || "Sorry, that item couldn't be added. Please try again.");
    } finally {
      adding = false;
      plusBtn.removeAttribute("aria-busy");
      setTimeout(() => plusBtn.classList.remove("is-adding", "is-added"), 800);
    }
  });
}

function initHeroSliders() {
  document.querySelectorAll("[data-hero-slider]").forEach((root) => {
    const slides = [...root.querySelectorAll("[data-hero-slide]")];
    const prevBtn = root.querySelector("[data-hero-prev]");
    const nextBtn = root.querySelector("[data-hero-next]");
    if (!slides.length) return;

    let index = Math.max(
      0,
      slides.findIndex((s) => s.classList.contains("is-active"))
    );
    let timer = null;
    let scheduledVideo = null;
    let videoEndedHandler = null;
    const autoplay = root.dataset.autoplay === "true";
    const interval = Math.max(3000, parseInt(root.dataset.interval, 10) || 4000);

    const getVisibleVideo = (slide) => {
      return [...slide.querySelectorAll("video.hero-slide__video")].find((video) => {
        const frame = video.closest("[data-hero-video-frame]");
        return frame && window.getComputedStyle(frame).display !== "none";
      });
    };

    const clearSchedule = () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      if (scheduledVideo && videoEndedHandler) {
        scheduledVideo.removeEventListener("ended", videoEndedHandler);
      }
      scheduledVideo = null;
      videoEndedHandler = null;
    };

    const syncSlideVideo = (slide, isActive) => {
      const visibleVideo = getVisibleVideo(slide);
      slide.querySelectorAll("video.hero-slide__video").forEach((video) => {
        if (isActive && video === visibleVideo) {
          video.play().catch(() => {
            video.dataset.heroPlaybackFailed = "true";
            scheduleNext();
          });
        } else {
          video.pause();
        }
      });
    };

    const scheduleNext = () => {
      clearSchedule();
      if (!autoplay || slides.length < 2) return;

      const currentVideo = getVisibleVideo(slides[index]);
      if (currentVideo && currentVideo.dataset.heroPlaybackFailed !== "true") {
        if (currentVideo.loop) return;
        scheduledVideo = currentVideo;
        videoEndedHandler = () => {
          scheduledVideo = null;
          videoEndedHandler = null;
          go(index + 1);
        };
        currentVideo.addEventListener("ended", videoEndedHandler, { once: true });
        return;
      }

      timer = setTimeout(() => go(index + 1), interval);
    };

    const go = (next) => {
      clearSchedule();
      index = ((next % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const on = i === index;
        slide.classList.toggle("is-active", on);
        slide.setAttribute("aria-hidden", on ? "false" : "true");
        slide.querySelectorAll("[data-hero-link]").forEach((link) => {
          link.tabIndex = on ? 0 : -1;
        });
        syncSlideVideo(slide, on);
      });
      scheduleNext();
    };

    prevBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      go(index - 1);
    });
    nextBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      go(index + 1);
    });

    root.addEventListener("mouseenter", clearSchedule);
    root.addEventListener("mouseleave", scheduleNext);
    window.addEventListener("resize", () => {
      syncSlideVideo(slides[index], true);
      scheduleNext();
    }, { passive: true });

    go(index);
  });
}
